import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const LoadingIndicator = ({ onDark, className }) => (
  <span
    className={classnames(
      "sal-loading-indicator",
      { ["sal-loading-indicator--light"]: onDark },
      className,
    )}
  >
    Laden...
  </span>
);

LoadingIndicator.propTypes = {
  onDark: PropTypes.bool,
  className: PropTypes.string,
};

export default LoadingIndicator;
